import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import CandidateDashboard from './dashboards/CandidateDashboard'
import AdminDashboard from './dashboards/AdminDashboard'
import RecruiterDashboard from './dashboards/RecruiterDashboard'

const DashboardPage: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth)

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  // Route to appropriate dashboard based on user role
  switch (user.role) {
    case 'candidate':
      return <CandidateDashboard />
    case 'admin':
      return <AdminDashboard />
    case 'recruiter':
      return <RecruiterDashboard />
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h2>
            <p className="text-gray-600">Invalid user role: {user.role}</p>
          </div>
        </div>
      )
  }
}

export default DashboardPage
